import { useTranslation } from 'next-i18next/pages';

import ContainerSection from '@pflegia/ui/shared/container-section';

import TrustpilotWidget, { TrustpilotWidgetType } from '@shared/components/trustpilot-widget/TrustpilotWidget';
import { EMPLOYER_COUNT } from '@shared/constants/counts';

// Rendered as wordmarks rather than the `EMPLOYER_LOGOS` images, per the hub design.
const EMPLOYER_NAMES = ['Bayerisches Rotes Kreuz', 'Parität', 'Bremer Heimstiftung', 'Alloheim', 'Hoftbauer Stiftung', 'Residenz-Gruppe'];

const Divider = () => <span className='hidden h-5 w-px bg-gray-200 md:block' aria-hidden />;

const TrustBar: React.FC = () => {
  const { t } = useTranslation('jobBoard', { keyPrefix: 'jobsPageHub.trustBar' });

  return (
    <div className='border-b border-gray-200'>
      <ContainerSection>
        <div className='flex flex-wrap items-center justify-center gap-x-6 gap-y-2 py-4 text-sm md:gap-x-8'>
          <span className='font-medium'>{t('usedByProfessionals')}</span>
          <Divider />
          <TrustpilotWidget type={TrustpilotWidgetType.MicroStar} />
          <Divider />
          <span className='font-medium'>{t('awardAsTopCareerPlatform')}</span>
        </div>

        <div className='flex flex-col gap-2 border-t border-gray-200 py-4 text-center text-sm md:flex-row md:items-center md:gap-x-8'>
          <span className='text-default md:shrink-0'>{t('employers', { employerCount: EMPLOYER_COUNT })}</span>
          <div className='flex min-w-0 flex-wrap justify-center gap-x-6 overflow-x-auto md:gap-x-6'>
            {EMPLOYER_NAMES.map(name => (
              <span className='text-secondary/60 whitespace-nowrap' key={name}>
                {name}
              </span>
            ))}
          </div>
        </div>
      </ContainerSection>
    </div>
  );
};

export default TrustBar;
